import { SpendSummaryContext } from '@/dashboards/SpendSummary/providers';
import { useContext } from 'use-context-selector';

export const useSpendSummaryContext = () => {
    return useContext(SpendSummaryContext);
};
